<template>
    <div>
        <p class="text-guide">
            {{ $t('paragraphs.file_transfer_tip1') }}<br>
            {{ $t('paragraphs.file_transfer_tip2', {count: file_transfer_enable_max_count}) }}
        </p>
        <div class="text-right mb-3"><button class="btn btn-primary" @click="openEditor()" v-if="haveSubmitRight && (file_transfers.length < file_transfer_max_count) && fileTransferAvailable">{{ $t('words.add') }}</button></div>
        <table class="table table-wide mb-0">
            <thead>
                <tr>
                    <th>{{ $t('words.file_transfer_kind') }}</th>
                    <th>{{ $t('words.title') }}</th>
                    <th>{{ $t('words.use_yes_no') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
            <tr v-for="file_transfer in file_transfers" :id="`file_transfer_${file_transfer.id}`" :key="file_transfer.id">
                <td>{{ transfer_kinds[file_transfer.kind] }}</td>
                <td>{{ file_transfer.title }}</td>
                <td>
                    <toggle-button v-model="file_transfer.status" :sync="true" :disabled="!haveSubmitRight" @change="changeStatus(file_transfer)"></toggle-button>
                </td>
                <td class="text-right">
                    <button class="btn btn-icon btn-flat" @click="openEditor(file_transfer)">
                        <i class="icon icon-edit"></i>
                    </button>
                    <button class="btn btn-icon btn-flat" v-if="haveSubmitRight" @click="doDelete(file_transfer)" >
                        <i class="icon icon-trash"></i>
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
        <div class="modal fade" id="editorModal" tabindex="-1" role="dialog" aria-labelledby="editorModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="hideChannelModalLabel">{{ $t('words.recording_file_transfer') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group row">
                            <label class="col-md-3 col-form-label" for="transfer_kind">{{ $t('words.file_transfer_kind') }}</label>
                            <div class="col-md-9">
                                <select id="transfer_kind" :class="{'custom-select':true, 'col-md-3':true, 'is-invalid':meta.errors.kind}" :disabled="editorModifyMode" v-model="editor_kind"  >
                                    <option>{{ $t('paragraphs.please_select') }}</option>
                                    <option v-for="(value, key) in transfer_kinds" :key="key" :value="key">
                                        {{ value }}
                                    </option>
                                </select>
                                <span class="invalid-feedback" v-if="meta.errors.kind" v-for="error in meta.errors.kind" :key="error">{{ error }}</span>
                            </div>
                        </div>
                        <div class="form-group row" v-if="editor_kind !== ''">
                            <label class="col-md-3 col-form-label" for="title">{{ $t('words.title') }}</label>
                            <div class="col-md-9">
                                <input type="text" id="title" name="title" maxlength="32" :class="{'form-control':true, 'is-invalid':meta.errors.title}"  v-model="editor_title" />
                                <span class="invalid-feedback" v-if="meta.errors.title" v-for="error in meta.errors.title" :key="error">{{ error }}</span>
                            </div>
                        </div>
                        <div v-if="editor_kind === 'ftp'">
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">Host</label>
                                <div class="col-md-9">
                                    <input type="text" id="host" name="host" :class="{'form-control':true, 'is-invalid':meta.errors.host}"  v-model="editor.host" />
                                    <span class="invalid-feedback" v-if="meta.errors.host" v-for="error in meta.errors.host" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">Port</label>
                                <div class="col-md-9">
                                    <input type="text" id="port" name="port" :class="{'form-control':true, 'is-invalid':meta.errors.port}"  v-model="editor.port" />
                                    <span class="invalid-feedback" v-if="meta.errors.port" v-for="error in meta.errors.port" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">Username</label>
                                <div class="col-md-9">
                                    <input type="text" id="username" name="username" :class="{'form-control':true, 'is-invalid':meta.errors.username}"  v-model="editor.username" />
                                    <span class="invalid-feedback" v-if="meta.errors.username" v-for="error in meta.errors.username" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">Password</label>
                                <div class="col-md-9">
                                    <input type="text" id="password" name="password" :class="{'form-control':true, 'is-invalid':meta.errors.password}"  v-model="editor.password" />
                                    <span class="invalid-feedback" v-if="meta.errors.password" v-for="error in meta.errors.password" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">{{ $t('paragraphs.remote_path_desc') }}</label>
                                <div class="col-md-9">
                                    <input type="text" id="remote_path" name="remote_path" :class="{'form-control':true, 'is-invalid':meta.errors.remote_path}"  v-model="editor.remote_path" />
                                    <span class="invalid-feedback" v-if="meta.errors.remote_path" v-for="error in meta.errors.remote_path" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3">{{ $t('words.use_yes_no') }}</label>
                                <div class="col-md-9">
                                    <toggle-button :sync="true" v-model="editor_status" :disabled="!haveSubmitRight"></toggle-button>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="editor_kind === 'sftp'">
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">Host</label>
                                <div class="col-md-9">
                                    <input type="text" id="host" name="host" :class="{'form-control':true, 'is-invalid':meta.errors.host}"  v-model="editor.host" />
                                    <span class="invalid-feedback" v-if="meta.errors.host" v-for="error in meta.errors.host" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">Port</label>
                                <div class="col-md-9">
                                    <input type="text" id="port" name="port" :class="{'form-control':true, 'is-invalid':meta.errors.port}"  v-model="editor.port" />
                                    <span class="invalid-feedback" v-if="meta.errors.port" v-for="error in meta.errors.port" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">Username</label>
                                <div class="col-md-9">
                                    <input type="text" id="username" name="username" :class="{'form-control':true, 'is-invalid':meta.errors.username}"  v-model="editor.username" />
                                    <span class="invalid-feedback" v-if="meta.errors.username" v-for="error in meta.errors.username" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">Password</label>
                                <div class="col-md-9">
                                    <input type="text" id="password" name="password" :class="{'form-control':true, 'is-invalid':meta.errors.password}"  v-model="editor.password" />
                                    <span class="invalid-feedback" v-if="meta.errors.password" v-for="error in meta.errors.password" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">{{ $t('paragraphs.remote_path_desc') }}</label>
                                <div class="col-md-9">
                                    <input type="text" id="remote_path" name="remote_path" :class="{'form-control':true, 'is-invalid':meta.errors.remote_path}"  v-model="editor.remote_path" />
                                    <span class="invalid-feedback" v-if="meta.errors.remote_path" v-for="error in meta.errors.remote_path" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3">{{ $t('words.use_yes_no') }}</label>
                                <div class="col-md-9">
                                    <toggle-button :sync="true" v-model="editor_status" :disabled="!haveSubmitRight" ></toggle-button>
                                    <span class="invalid-feedback" v-if="meta.errors.status" v-for="error in meta.errors.status" :key="error">{{ error }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="editor_kind === 'kollus'">
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">Host</label>
                                <div class="col-md-9">
                                    <input type="text" id="host" name="host" :class="{'form-control':true, 'is-invalid':meta.errors.host}"  v-model="editor.host" />
                                    <span class="invalid-feedback" v-if="meta.errors.host" v-for="error in meta.errors.host" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">Username</label>
                                <div class="col-md-9">
                                    <input type="text" id="username" name="username" :class="{'form-control':true, 'is-invalid':meta.errors.username}"  v-model="editor.username" />
                                    <span class="invalid-feedback" v-if="meta.errors.username" v-for="error in meta.errors.username" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">Password</label>
                                <div class="col-md-9">
                                    <input type="text" id="password" name="password" :class="{'form-control':true, 'is-invalid':meta.errors.password}"  v-model="editor.password" />
                                    <span class="invalid-feedback" v-if="meta.errors.password" v-for="error in meta.errors.password" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">{{ $t('words.category_key') }}</label>
                                <div class="col-md-9">
                                    <input type="text" id="category_key" name="category_key" :class="{'form-control':true, 'is-invalid':meta.errors.category_key}"  v-model="editor.category_key" />
                                    <span class="invalid-feedback" v-if="meta.errors.category_key" v-for="error in meta.errors.category_key" :key="error">{{ error }}</span>
                                    <small class="form-text text-muted">
                                        {{ $t('paragraphs.kollus_category_tip1') }}<br>
                                        {{ $t('paragraphs.kollus_category_tip2') }}
                                    </small>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3">{{ $t('words.use_encryption') }}</label>
                                <div class="col-md-9">
                                    <toggle-button :sync="true" v-model="editor.use_encryption" :disabled="!haveSubmitRight" ></toggle-button>
                                    <span class="invalid-feedback" v-if="meta.errors.use_encryption" v-for="error in meta.errors.use_encryption" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3">{{ $t('words.use_yes_no') }}</label>
                                <div class="col-md-9">
                                    <toggle-button :sync="true" v-model="editor_status" :disabled="!haveSubmitRight" ></toggle-button>
                                    <span class="invalid-feedback" v-if="meta.errors.status" v-for="error in meta.errors.status" :key="error">{{ error }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="editor_kind === 's3'">
                            <div class="form-group row">
                                <label class="col-md-3">bucket_name<br/>({{ $t('words.aws_bucket_name_desc')}})</label>
                                <div class="col-md-9">
                                    <input type="text" id="bucket_name" name="bucket_name" :class="{'form-control':true, 'is-invalid':meta.errors.bucket_name}"  v-model="editor.bucket_name" />
                                    <span class="invalid-feedback" v-if="meta.errors.bucket_name" v-for="error in meta.errors.bucket_name" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3">aws_access_key_id<br/>({{ $t('words.aws_access_key_id_desc')}})</label>
                                <div class="col-md-9">
                                    <input type="text" id="aws_access_key_id" name="aws_access_key_id" :class="{'form-control':true, 'is-invalid':meta.errors.aws_access_key_id}"  v-model="editor.aws_access_key_id" />
                                    <span class="invalid-feedback" v-if="meta.errors.aws_access_key_id" v-for="error in meta.errors.aws_access_key_id" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3">aws_secret_access_key<br/>({{ $t('words.aws_secret_access_key_desc')}})</label>
                                <div class="col-md-9">
                                    <input type="text" id="aws_secret_access_key" name="aws_secret_access_key" :class="{'form-control':true, 'is-invalid':meta.errors.aws_secret_access_key}"  v-model="editor.aws_secret_access_key" />
                                    <span class="invalid-feedback" v-if="meta.errors.aws_secret_access_key" v-for="error in meta.errors.aws_secret_access_key" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">   <!-- 2019-06-18 jinseok.oh add -->
                                <label class="col-md-3">region<br/>({{ $t('words.aws_region_key_desc')}})</label>
                                <div class="col-md-9">
                                    <input type="text" id="aws_region_key" name="aws_region_key" :class="{'form-control':true, 'is-invalid':meta.errors.aws_region_key}"  v-model="editor.aws_region_key" />
                                    <span class="invalid-feedback" v-if="meta.errors.aws_region_key" v-for="error in meta.errors.aws_region_key" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3">{{ $t('words.use_yes_no') }}</label>
                                <div class="col-md-9">
                                    <toggle-button :sync="true" v-model="editor_status" :disabled="!haveSubmitRight"></toggle-button>
                                    <span class="invalid-feedback" v-if="meta.errors.status" v-for="error in meta.errors.status" :key="error">{{ error }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="editor_kind === 'youtube'">
                            <div class="form-group row">
                                <label class="col-md-3">{{ $t('words.authentication') }}</label>
                                <div class="col-md-9">
                                    <div v-if="haveGoogleAuth()">
                                        {{ editor.user_data.email }}
                                        <button class="btn btn-icon btn-flat" v-if="haveSubmitRight" @click.prevent="doLogoutGoogle(editor)" >
                                            <i class="icon icon-trash"></i>
                                        </button>
                                    </div>
                                    <div v-else>
                                        <a href="" target='_blank' class="text-link" v-if="haveSubmitRight" @click.prevent="signInGoogle" >{{ $t('words.google_auth_go')}}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-form-label">{{ $t('words.category') }}</label>
                                <div class="col-md-9">
                                    <select id="youtube_categories" :class="{'custom-select':true, 'col-md-3':true, 'is-invalid':meta.errors.category}" v-model="editor.category"  >
                                        <!--<option>{{ $t('paragraphs.please_select') }}</option>-->
                                        <option v-if="editor_categories" v-for="category in editor_categories" :key="category.id" :value="category.id">
                                            {{ category.title }}
                                        </option>
                                    </select>
                                    <span class="invalid-feedback" v-if="meta.errors.category" v-for="error in meta.errors.category" :key="error">{{ error }}</span>
                                    <br><small class="form-text text-muted">{{ $t('paragraphs.youtube_category_tip1')}}<br>{{ $t('paragraphs.youtube_category_tip2')}}</small>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3">{{ $t('words.shared_status') }}</label>
                                <div class="col-md-9">
                                    <toggle-button :sync="true" v-model="editor.privateStatus" :disabled="!haveSubmitRight" ></toggle-button>
                                    <span class="invalid-feedback" v-if="meta.errors.privateStatus" v-for="error in meta.errors.privateStatus" :key="error">{{ error }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3">{{ $t('words.use_yes_no') }}</label>
                                <div class="col-md-9">
                                    <toggle-button :sync="true" v-model="editor_status" :disabled="!haveSubmitRight" ></toggle-button>
                                    <span class="invalid-feedback" v-if="meta.errors.status" v-for="error in meta.errors.status" :key="error">{{ error }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="ml-auto" v-if="haveSubmitRight">
                            <button class="btn btn-secondary mr-2" @click="closeEditor()" >{{ $t('words.cancel') }}</button>
                            <button class="btn btn-primary" @click="doUpdate()" v-if="editor_kind !== ''" ><span v-if="editor_id===-1">{{ $t('words.register') }}</span><span v-else>{{ $t('words.edit') }}</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// google config 가져오는 부분이 있어서 남겨둠.
import { mapGetters } from 'vuex';
import Vue from 'vue';
import GoogleAuth from 'vue-google-oauth';
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    props: {
        channel: {
            type: [Object],
            require: true,
        },
        modifyMode: {
            type: [Boolean],
            require: true,
        },
        currentTab: {
            type: [String],
            require: true,
        },
    },
    data() {
        return {
            tab_name: 'file_transfer',
            file_transfer_enable_max_count: 3,
            file_transfer_max_count: 10,
            transfer_kinds: {
                ftp: 'ftp',
                // 기존의 설정 정보를 google 에서 비활성화시켜서 막음 처리
                // youtube: 'YouTube',
                sftp: 'Sftp',
                s3: 'Amazon S3',
                kollus: 'Kollus',
            },
            meta: {
                errors: {
                },
            },
            file_transfers: {},
            editor_id: -1,
            editor_kind: '',
            editor_title: '',
            editor_status: false,
            editor_categories: [],
            editor: {
                host: '',
                port: '',
                username: '',
                password: '',
                remote_path: '',
                ftp: '',
                category_key: '',
                use_encryption: false,
                aws_access_key_id: '',
                aws_secret_access_key: '',
                bucket_name: '',
                user_data: '',
                user_token: '',
                category: '',
                privateStatus: false,
                aws_region_key: '',
            },
            ftp_data: [
                'host', 'port', 'username', 'password', 'remote_path',
            ],
            sftp_data: [
                'host', 'port', 'username', 'password', 'remote_path',
            ],
            kollus_data: [
                'host', 'username', 'password', 'category_key', 'use_encryption',
            ],
            youtube_data: [
                'email', 'access_token', 'category', 'upload_open', 'user_data', 'user_token', 'privateStatus',
            ],
            s3_data: [
                'aws_access_key_id', 'aws_secret_access_key', 'bucket_name', 'aws_region_key',
            ],
        };
    },
    mounted() {
    },
    methods: {
        initialGoogle() {
            Vue.use(GoogleAuth, { client_id: this.getGoogleConfig.client_id, scope: this.getGoogleConfig.scope });

            this.$googleAuth().load();
        },
        signInGoogle() {
            if (!this.haveSubmitRight) {
                return;
            }

            try {
                this.$googleAuth().signIn((authorizationCode) => {
                    axios.get(`/cms/${this.selectedServiceAccount.key}/google/auth?code=${authorizationCode}`).then((response) => {
                        const { data } = response;

                        this.editor.user_data = data.user_data;
                        this.editor.user_token = data.token;
                        this.getYoutubeCategory();
                    }).catch((error) => {
                        console.log(error);
                        this.$toasted.error(this.$t('paragraphs.message.error.google_auth'));
                    });
                }, (error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.google_auth'));
                });
            } catch (e) {
                console.log(e);

                this.$toasted.error(this.$t('paragraphs.message.error.google_auth'));
                location.reload();
            }
        },
        getYoutubeCategory() {
            const self = this;
            axios.post(`/cms/${this.selectedServiceAccount.key}/google/youtube_categories`, {
                token: this.editor.user_token,
                timezone: window.Laravel.lang,
            }).then((response) => {
                self.editor_categories = response.data.categories;
                if (!self.editorModifyMode) {
                    this.$toasted.info(this.$t('paragraphs.loaded_youtube_category'));
                }
            }).catch((error) => {
                self.meta.errores = error.response.data.errors;
            });
        },
        doLogoutGoogle() {
            if (!this.haveSubmitRight) {
                return;
            }

            const self = this;
            axios.post(`/cms/${this.selectedServiceAccount.key}/google/logout`, { token: this.editor.user_token }).then((response) => {
                self.editor.user_token = '';
                self.editor.user_data = '';
                self.editor_categories = [];
                self.editor.privateStatus = false;

                if (self.editorModifyMode) {
                    axios.get(`${this.fileTransferApi}/${this.editor_id}/reset_google_auth`).then((responseS) => {
                    }).catch((error) => {
                        self.meta.errors = error.response.data.errors;
                        if (typeof error.response.data.errors === 'undefined' && typeof error.response.data.message === 'string' && error.response.data.message !== '') {
                            this.$toasted.error(error.response.data.message);
                        } else {
                            self.$toasted.error(this.$t('paragraphs.message.error.update'));
                        }
                    });
                }
            }).catch((error) => {
                self.meta.errores = error.response.data.errors;
                this.$toasted.error(this.$t('paragraphs.error.logout_google_auth'));
            });
        },
        initialize() {
            this.loadFileTransfers();
        },
        loadFileTransfers() {
            const self = this;
            axios.get(this.fileTransferApi).then((response) => {
                self.file_transfers = response.data.data;
                self.file_transfer_max_count = response.data.meta.file_transfer_max_count;
                self.file_transfer_enable_max_count = response.data.meta.file_transfer_enable_max_count;
            }).catch((error) => {
                self.meta.errors = error.response.data.errors;
            });
        },
        initializeEditor() {
            this.meta.errors = {};
            this.editor_kind = '';
            this.editor_title = '';
            this.editor_id = -1;
            this.editor_categories = [];
            this.editor = {
                host: '',
                port: '',
                username: '',
                password: '',
                remote_path: '',
                ftp: '',
                category_key: '',
                use_encryption: false,
                aws_access_key_id: '',
                aws_secret_access_key: '',
                bucket_name: '',
                user_data: '',
                user_token: '',
                category: '',
                privateStatus: false,
            };
            this.editor_status = false;
        },
        openEditor(fileTransfer = null) {
            this.initializeEditor();
            if (fileTransfer != null) {
                this.editor_id = fileTransfer.id;
                this.editor_title = fileTransfer.title;
                if (fileTransfer.data !== null) {
                    this.editor = fileTransfer.data;
                }
                this.editor_kind = fileTransfer.kind;
                this.editor_status = fileTransfer.status;

                if (this.editor_kind === 'youtube') {
                    if (this.haveGoogleAuth()) {
                        this.getYoutubeCategory();
                    }
                }
            }
            $('#editorModal').modal();
        },
        closeEditor() {
            this.initializeEditor();
            $('#editorModal').modal('hide');
        },
        doUpdate() {
            if (!this.haveSubmitRight) {
                return;
            }

            const self = this;
            let pickedData = {};
            if (this.editor_kind === 'ftp') {
                pickedData = _.pick(this.editor, this.ftp_data);
            } else if (this.editor_kind === 'sftp') {
                pickedData = _.pick(this.editor, this.sftp_data);
            } else if (this.editor_kind === 'kollus') {
                pickedData = _.pick(this.editor, this.kollus_data);
            } else if (this.editor_kind === 'youtube') {
                pickedData = _.pick(this.editor, this.youtube_data);
            } else if (this.editor_kind === 's3') {
                pickedData = _.pick(this.editor, this.s3_data);
            }
            self.meta.errors = {};

            if (this.editor_kind === 'youtube' && (typeof this.editor.user_data !== 'object' || typeof this.editor.user_token !== 'object')) {
                this.$toasted.error(this.$t('paragraphs.please_google_auth'));
                return;
            }

            if (this.editor_id === -1) {
                axios.post(this.fileTransferApi, {
                    kind: this.editor_kind,
                    title: this.editor_title,
                    data: pickedData,
                    status: this.editor_status,
                }).then((response) => {
                    self.file_transfers.push(response.data);
                    self.closeEditor();
                }).catch((error) => {
                    self.meta.errors = error.response.data.errors;
                    if (typeof error.response.data.errors === 'undefined' && typeof error.response.data.message === 'string' && error.response.data.message !== '') {
                        this.$toasted.error(error.response.data.message);
                    } else {
                        self.$toasted.error(this.$t('paragraphs.message.error.create'));
                    }
                });
            } else {
                axios.put(`${this.fileTransferApi}/${this.editor_id}`, {
                    id: this.editor_id,
                    title: this.editor_title,
                    kind: this.editor_kind,
                    data: pickedData,
                    status: this.editor_status,
                }).then((response) => {
                    self.loadFileTransfers();
                    self.closeEditor();
                }).catch((error) => {
                    self.meta.errors = error.response.data.errors;
                    if (typeof error.response.data.errors === 'undefined' && typeof error.response.data.message === 'string' && error.response.data.message !== '') {
                        this.$toasted.error(error.response.data.message);
                    } else {
                        self.$toasted.error(this.$t('paragraphs.message.error.update'));
                    }
                });
            }
        },
        changeStatus(fileTransfer) {
            const lFileTransfer = Object.create(fileTransfer);
            if (!this.haveSubmitRight) {
                return;
            }

            axios.put(`${this.fileTransferApi}/${lFileTransfer.id}/change_status`, { status: lFileTransfer.status }).then(() => {
                this.$toasted.success(this.$t('paragraphs.message.success.update'));
            }).catch((error) => {
                if (lFileTransfer.status) {
                    lFileTransfer.status = false;
                } else {
                    lFileTransfer.status = true;
                }
                if (typeof error.response.data.errors === 'undefined' && typeof error.response.data.message === 'string' && error.response.data.message !== '') {
                    this.$toasted.error(error.response.data.message);
                }
            });
        },
        doDelete(fileTransfer) {
            if (!this.haveSubmitRight) {
                return;
            }

            if (confirm(this.$t('paragraphs.message.confirm.remove_item'))) {
                axios.delete(`${this.fileTransferApi}/${fileTransfer.id}`).then((response) => {
                    this.loadFileTransfers();
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.remove'));
                });
            }
        },
        haveGoogleAuth() {
            return this.editor !== null && typeof this.editor.user_token === 'object' && typeof this.editor.user_data === 'object';
        },
    },
    computed: {
        ...mapGetters([
            'getGoogleConfig',
        ]),
        fileTransferApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.channel.id}/file_transfers`;
        },
        editorModifyMode() {
            return this.editor_id !== -1;
        },
        haveSubmitRight() {
            return (!this.modifyMode && this.haveOwnerRight) || (this.modifyMode && this.haveManagerRight);
        },
        loadedChannel() {
            return this.loadedServiceAccount && ('id' in this.channel) && (this.channel.id !== '');
        },
        selectedTab() {
            return this.loadedChannel && this.currentTab === this.tab_name;
        },
    },
    watch: {
        selectedTab(newValue) {
            if (newValue) {
                this.initialize();
            }
        },
        getGoogleConfig(newValue, oldValue) {
            if (typeof newValue !== 'undefined') {
                this.initialGoogle();
            }
        },
    },
};

</script>
<style>
</style>
